var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrlPasteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55556 0H4.88889C3.54444 0 2.44444 1 2.44444 2.22222C1.1 2.22222 0 3.22222 0 4.44444V7.77778C0 9 1.1 10 2.44444 10H6.11111C7.45556 10 8.55556 9 8.55556 7.77778C9.9 7.77778 11 6.77778 11 5.55556V2.22222C11 1 9.9 0 8.55556 0ZM7.33333 7.77778C7.33333 8.38889 6.78333 8.88889 6.11111 8.88889H2.44444C1.77222 8.88889 1.22222 8.38889 1.22222 7.77778V4.44444C1.22222 3.83333 1.77222 3.33333 2.44444 3.33333H6.11111C6.78333 3.33333 7.33333 3.83333 7.33333 4.44444V7.77778ZM9.77778 5.55556C9.77778 6.16667 9.22778 6.66667 8.55556 6.66667V4.44444C8.55556 3.22222 7.45556 2.22222 6.11111 2.22222H3.66667C3.66667 1.61111 4.21667 1.11111 4.88889 1.11111H8.55556C9.22778 1.11111 9.77778 1.61111 9.77778 2.22222V5.55556Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlPasteBlack);
export default __webpack_public_path__ + "static/media/url-paste-black.bfa20b119ef14f29f2500f95066c7726.svg";
export { ForwardRef as ReactComponent };